// extracted by mini-css-extract-plugin
export default {"body":"Hero_body__zPFMw","logo":"Hero_logo__tbbdS","left":"Hero_left__8dJE-","breadcrumbs":"Hero_breadcrumbs__VpsyK","cart":"Hero_cart__YByCw"};